import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';

import { InputBoardComponent } from './inputboard/inputboard.component';
import { DonutChartModule } from '../cp-donutchart/cp-donutchart.module';
import { TwoBarschartModule } from '../cp-twobarschart/cp-twobarschart.module';
import { GaugeChartModule } from '../cp-gauge/cp-gauge.module';
import { CpWidgetModule } from '../cp-widget/cp-widget.module';
import { InputTasksComponent } from './inputtasks/inputtasks.component';
import { LoadingButtonModule } from '../cp-loadingbutton/cp-loadingbutton.module';
import { InputDisclaimerGroupModule } from '../cp-inputdisclaimergroup/cp-inputdisclaimergroup.module';
import { TaskChartsModule } from '../Task/taskcharts/taskcharts.module';
import { InputChartsModule } from './inputcharts/inputcharts.module';

@NgModule({
  declarations: [
    InputBoardComponent,
    InputTasksComponent
  ],
  imports: [
    CommonModule,
    PoModule,
    DonutChartModule,
    GaugeChartModule,
    TwoBarschartModule,
    CpWidgetModule,
    LoadingButtonModule,
    InputDisclaimerGroupModule,
    TaskChartsModule,
    InputChartsModule
  ],
  exports: [
    InputBoardComponent
  ]
})

export class InputModule{}
